var map = {
	"./apollographql.svg": 6123,
	"./bootstrap.svg": 3722,
	"./createreactapp.svg": 9625,
	"./css3.svg": 5594,
	"./figma.svg": 3778,
	"./flutter.svg": 7152,
	"./freecodecamp.svg": 6080,
	"./gatsby.svg": 1612,
	"./git.svg": 6487,
	"./github.svg": 2250,
	"./grafana.svg": 4062,
	"./graphQL.svg": 5364,
	"./html5.svg": 4645,
	"./intellijidea.svg": 4722,
	"./javascript.svg": 3186,
	"./jquery.svg": 7953,
	"./mongodb.svg": 6442,
	"./nextdotjs.svg": 1236,
	"./node.svg": 2114,
	"./nuxtdotjs.svg": 8513,
	"./photoshop.svg": 4176,
	"./postgreSQL.svg": 3817,
	"./react.svg": 7390,
	"./reactquery.svg": 6076,
	"./rss.svg": 8006,
	"./sass.svg": 4077,
	"./spring-boot.svg": 3819,
	"./spring.svg": 3009,
	"./styledcomponents.svg": 7007,
	"./twitter.svg": 5510,
	"./typescript.svg": 6199,
	"./visualstudiocode.svg": 3017,
	"./vue.svg": 5635
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9896;